import {
  isAdmin, isPolicyTeam, isStrategyTeam, isMediaCenter_tst,
} from '../../../services/rolesSvc';
import { NewsMode } from './NewsMode';

export class MilestoneNewsMode extends NewsMode {
  navCtx;

  constructor({
    id, api, navCtx,
  }) {
    super({ id, api });
    this.navCtx = {
      strategyId: navCtx.strategyId ? parseInt(navCtx.strategyId) : null,
      policyId: navCtx.policyId ? parseInt(navCtx.policyId) : null,
      projId: navCtx.projId ? parseInt(navCtx.projId) : null,
    };
    this.settings = {
      save: {
        title: 'Опубликовать',
        action: (dto, postImage) => this.api.postFileFixed(`/projs/${this.navCtx.projId}/milestones/${this.id}/approve`, dto, postImage),
        afterActionMessages: ['Веха согласована', 'Веха опубликована в разделе «Новости»'],
      },
      callbackUrl: this.navCtx.strategyId
        ? `/strats/${this.navCtx.strategyId}/report/milestones`
        : `/policies/${this.navCtx.policyId}/report/milestones`,
    };
  }

  canEdit = (userCtx) => isAdmin(userCtx)
    || isMediaCenter_tst(userCtx)
    || isStrategyTeam(userCtx, this.navCtx.strategyId)
    || !this.navCtx.strategyId && isPolicyTeam(userCtx, this.navCtx.policyId);

  get = (id) => this.api.get(`/news/milestone/${id}`);
}
